/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_Act_WaveInputs */

const en_of_landing_act_wave = /** @type {(inputs: Of_Landing_Act_WaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wave them over`)
};

const id_of_landing_act_wave = /** @type {(inputs: Of_Landing_Act_WaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sapa dengan lambaian`)
};

/**
* | output |
* | --- |
* | "Wave them over" |
*
* @param {Of_Landing_Act_WaveInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_act_wave = /** @type {((inputs?: Of_Landing_Act_WaveInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_Act_WaveInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_act_wave(inputs)
	return en_of_landing_act_wave(inputs)
});